# Why Run Local?

Most devs either rely entirely on cloud AI or avoid it altogether

Local models offer a compelling middle ground:

---

**Zero recurring costs** — no API bills, unlimited tokens

**Privacy by default** — proprietary code never leaves your machine

**Always available** — no rate limits, no outages, works offline

**Full control** — customize, fine-tune, experiment freely